<template>
  <div class="print">
    <div class="contents">
      <div class="title">{{ $t('안전보건관리책임자 선임계') }}</div>

      <div class="userInfo">
        <p><span class="label">{{ $t('소속명') }}</span><span class="colon">:</span>{{ form.inputC_2 }}</p>
        <p><span class="label">{{ $t('직책') }}</span><span class="colon">:</span>{{ form.inputC_3 }}</p>
        <p><span class="label">{{ $t('성명') }}</span><span class="colon">:</span>{{ form.inputC_1 }}</p>
      </div>

      <div class="message">
        <p class="intro">{{ $t('위 사람을 산업안전보건법 제15조 및 동법 시행령 제14조에 의거 안전·보건 업무를 총괄 관리할 안전보건관리책임자로 선임합니다. 아래의 업무를 충실히 수행하여 주시기 바랍니다.') }}</p>

        <p class="head">{{ $t('※ 안전보건관리책임자의 업무내용') }}</p>
        <p class="item">{{ $t('1. 사업장의 산업재해 예방계획의 수립에 관한 사항') }}</p>
        <p class="item">{{ $t('2. 안전보건관리규정의 작성 및 변경에 관한 사항') }}</p>
        <p class="item">{{ $t('3. 안전보건교육에 관한 사항') }}</p>
        <p class="item">{{ $t('4. 작업환경측정 등 작업환경의 점검 및 개선에 관한 사항') }}</p>
        <p class="item">{{ $t('5. 근로자의 건강진단 등 건강관리에 관한 사항') }}</p>
        <p class="item">{{ $t('6. 산업재해의 원인 조사 및 재발 방지대책 수립에 관한 사항') }}</p>
        <p class="item">{{ $t('7. 산업재해에 관한 통계의 기록 및 유지에 관한 사항') }}</p>
        <p class="item">{{ $t('8. 안전장치 및 보호구 구입 시 적격품 여부 확인에 관한 사항') }}</p>
        <p class="item">{{ $t('9. 위험성평가의 실시에 관한 사항과 안전보건규칙에서 정하는 근로자의 위험 또는 건강장해의 방지에 관한 사항') }}</p>
        <p class="item">{{ $t('10. 그 밖에 근로자의 유해·위험 방지조치에 관한 사항으로서 고용노동부령으로 정하는 사항') }}</p>
      </div>

      <div class="sign">
        <div class="yyyyMMdd">
          <span class="pr-4">{{ appointDate.getFullYear() }} {{ $t('년') }}</span>
          <span class="pr-4">{{ appointDate.getMonth() + 1 }}{{ $t('월') }}</span>
          <span>{{ appointDate.getDate() }}{{ $t('일') }}</span>
        </div>

        <!-- 공단 CI + 이사장(고정) + 직인 (297 Print 와 동일 구성) -->
        <div class="footer">
          <img class="ci" src="@/assets/images/print/semas_ci.png" alt="소상공인시장진흥공단" />
          <span class="position">{{ $t('이사장') }}</span>
          <span class="name">인 태 연</span>
          <img class="stamp" src="@/assets/images/print/semas_stamp.png" alt="직인" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Print282",
  props: {
    border: Object,
    form: Object,
  },
  computed: {
    appointDate () {
      const d = new Date(this.form.inputC_5)
      return isNaN(d.getTime()) ? new Date('2026-07-27') : d
    },
  },
};
</script>

<style lang="scss" scoped>
/* A4 세로 인쇄 기준 (tab-items 282 의 printPageSize: "a4") — 297 Print 와 동일 스타일 */
.print {
  padding: 1rem;
  color: #222;

  & > .contents {
    display: grid !important;
    width: 100%;
    height: auto;
    padding: 1rem 1.5rem;
  }
}

/* 제목 크기 2.07rem(≈29px): 하단 CI·이사장·성명을 제목과 같은 글자 높이로 두고 직인(25mm)과 함께
   A4 한 줄(가용 폭 약 181mm)에 넣을 수 있는 최대값. 2.5rem 이면 약 220mm 가 필요해 두 줄이 된다 (2026-10-29) */
.title {
  padding: 0.5rem 0;
  margin-bottom: 1rem;

  text-align: center;
  font-size: 2.07rem;
  font-weight: 800;
  letter-spacing: 0.1em;
}

.userInfo {
  margin: 0 0 1.5rem 2rem;

  & > p {
    font-size: 1.25rem;
    font-weight: 700;
    line-height: 2.25rem;

    .label {
      display: inline-block;
      width: 4.5em;
      text-align: justify;
      text-align-last: justify;
    }
    .colon {
      display: inline-block;
      width: 1.5em;
      text-align: center;
    }
  }
}

.message {
  p {
    font-size: 1.125rem;
    font-weight: 400;
    line-height: 1.75rem;
    margin: 0;
  }

  .intro {
    font-weight: 500;
    text-indent: 1em;
    margin-bottom: 1.25rem;
  }

  .head {
    font-weight: 700;
    margin-bottom: 0.5rem;
  }

  .item {
    padding-left: 2.75rem;
    text-indent: -1.5rem;
  }

  .sub {
    padding-left: 3.75rem;
  }
}

.sign {
  padding-top: 1.25rem;
  break-inside: avoid;
  page-break-inside: avoid;

  .yyyyMMdd {
    display: flex;
    justify-content: center;
    font-size: 1.5rem;
    font-weight: 700;

    margin-bottom: 1.25rem;
  }

  .footer {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;

    /* CI 글자(소상공인시장진흥공단) 높이를 제목(.title) 글자 높이와 맞춘다.
       semas_ci.png(1588×367) 에서 글자 영역 높이는 122px(전체의 33%) 이고 제목 한글 글자 높이는
       글꼴 크기의 약 97% 이므로 이미지 높이 = 제목 크기 × 0.97 × 367/122 ≈ 제목 크기 × 2.92 → 2.07rem × 2.92 ≈ 6.05rem (폭 약 97mm) */
    .ci {
      height: 6.05rem;
      width: auto;
      flex: 0 0 auto;
    }

    /* 이사장·성명 글자 크기는 제목(.title)과 동일. 간격은 한 줄 배치를 위해 최소로 */
    .position {
      font-size: 2.07rem;
      font-weight: 700;
      white-space: nowrap;
    }

    .name {
      font-size: 2.07rem;
      font-weight: 700;
      margin-left: 0.25rem;
      white-space: nowrap;
    }

    /* 직인 실제 크기 2.5cm×2.5cm. 이미지(324×312px) 바깥에 투명 여백이 있고 인면은 297×295px 이므로
       인면이 25mm 가 되도록 이미지 폭을 25mm × 324/297 ≈ 27.3mm 로 둔다 (세로는 비율 유지, 인면 약 25mm) */
    .stamp {
      width: 27.3mm;
      height: auto;
      flex: 0 0 auto;
      /* 직인 이미지의 흰 배경을 비치게 하여 자연스럽게 겹치도록 */
      mix-blend-mode: multiply;
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }
  }
}

/* 인쇄 배치: 제목 → (2.5rem) → 인적사항 → (2.5rem) → 본문(행간 1.3배) 순으로 상단부터 흐르고,
   날짜·서명(.sign)은 margin-top: auto 로 페이지 하단에 고정. .print 높이는 A4(297mm) 에서
   브라우저 기본 인쇄 여백(약 10mm×2)을 뺀 값보다 여유 있게 잡아 빈 2페이지가 생기지 않게 한다.
   화면(미리보기)에는 영향 없음. */
@media print {
  .print {
    box-sizing: border-box;
    min-height: 265mm;
    display: flex;
    flex-direction: column;
    /* 하단 CI·이사장·직인 확대(2026-10-29) 이후 가로·세로 여유가 없어 인쇄 시 패딩 제거
       (인쇄 창 body 16px + 용지 여백이 이미 있음). 하단 한 줄 폭 약 170mm 가 가용 폭 181mm 안에 들어간다 */
    padding: 0;

    & > .contents {
      display: flex !important;
      flex-direction: column;
      flex: 1 1 auto;
      padding: 0;
    }
  }

  .title {
    margin-bottom: 2.5rem;
  }

  /* 제목↔인적사항과 같은 간격으로 본문을 붙인다 */
  .userInfo {
    margin-bottom: 2.5rem;
  }

  /* 본문 행간 1.3배 (기본 1.75rem × 1.3). 하단을 한 줄로 배치한 뒤에는 A4 한 장(가용 265mm)에 여유 있게 들어간다 */
  .message p {
    line-height: 2.275rem;
  }

  .sign {
    margin-top: auto;
    padding-top: 0; /* margin-top: auto 가 간격을 만들므로 불필요 */
  }
}
</style>
